"use client";

import PopularListItemCard from "@/components/PopularListItemCard";
import OpportunitiesCardWrapper from "@/components/OpportunitiesCardWrapper";
import AbroadHotels from "@/components/pages/hotel/sections/AbroadHotels";
import PopularLocationCard from "@/components/PopularLocationCard";
import HotelPopularLocations from "@/components/pages/hotel/landings/HotelPopularLocations";
import { BlogCard, CampaignCard } from "@/components/featured/common";

export const hotelHomeComponentRegistry = {
  OpportunitiesCardWrapper,
  CampaignCard,
  PopularListItemCard,
  BlogCard,
  PopularListItemCard,
  AbroadHotels,
  PopularLocationCard,
  HotelPopularLocations
};

export const hotelHomeItemPropMapping = {
  OpportunitiesCardWrapper: "stats",
  CampaignCard: "item",
  PopularListItemCard: "item",
  BlogCard: "post",
  PopularListItemCard: "item",
  AbroadHotels : "item",
  PopularLocationCard: "item",
};
